import { AppQueryParams } from '@doda/common/src/constants/queryParams';
import { AreaListOfSearchModal } from '@doda/common/src/models/MasterCacheModel';
import { ABROAD_AREA_NUMBER } from '@doda/common/src/constants/properties/const';

/**
 * 都道府県のAPIリクエスト作成
 * @param queryParams クエリパラメータ
 * @param areas エリアのマスタ
 * @returns 都道府県のAPIリクエスト
 */
export const createPrefectureApiRequest = (
  queryParams: AppQueryParams,
  areas: AreaListOfSearchModal[] | null
) => {
  let prefectureName = '';
  let pr = '';
  let requestPrefectureId: string[] | undefined = [];

  const prefectureList = areas?.flatMap(
    (areaValue) => areaValue.prefectureList
  );
  if (queryParams.pr) [pr] = queryParams.pr;
  const findPr = prefectureList?.find((prefecture) => prefecture.id === pr);
  if (pr === ABROAD_AREA_NUMBER) {
    // 海外は求人コンテンツの表示対象外
    throw new Error('求人コンテンツ表示対象外のパラメータ(pr)');
  }
  if (findPr) {
    prefectureName = findPr.name;
    requestPrefectureId = queryParams.pr ?? [];
  } else {
    // マスタに存在しない不正な値
    throw new Error('パラメータの不正(pr)');
  }

  return { prefectureName, requestPrefectureId };
};
